import {l} from "types/typescriptdefinisjoner_lederplan";
import angular, {IAttributes, IAugmentedJQuery, IScope} from "angular";
import {regNavn} from "../tjenester/tredjepartsTjenestenavn";
import {Kontekst} from "../tjenester/Kontekst";
import _ from "lodash";

export function kreverTilgangsrolleGrpForInjisering() {
    return [regNavn.ng.$animate, Kontekst.regNavn, kreverTilgangsrolleGrp];
}

/**
 * Attributt-direktiv som skjuler taggen dersom bruker ikke har angitt rolle i angitt gruppe.
 * Dersom ingen gruppeId er angitt sjekkes det hvorvidt bruker har angitt role i noen av sine grupper.
 *
 * Dersom rolle prefikses med '!' vises taggen dersom bruker IKKE har rollen.
 *
 * Bruk: <a krever-tilgangsrolle-grp="{rolle: 'rollenavn', gruppeId:<gruppeid>>}">....</a>,
 * elementet vil vises dersom kontekst.inneharTilgangsrolleIGruppe("rollenavn", gruppeId) returnerer sann.
 */
export function kreverTilgangsrolleGrp($animate, kontekst: Kontekst): any /*IDirective */ {

    //KOPIERT FRA angualar.js
    var slice = [].slice;
    var jqLite = angular.element;

    function getBlockNodes(nodes) {
        // TODO(perf): update `nodes` instead of creating a new object?
        var node = nodes[0];
        var endNode = nodes[nodes.length - 1];
        var blockNodes;

        for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
            if (blockNodes || nodes[i] !== node) {
                if (!blockNodes) {
                    blockNodes = jqLite(slice.call(nodes, 0, i));
                }
                blockNodes.push(node);
            }
        }

        return blockNodes || nodes;
    }

    return {
        multiElement: true,
        transclude: 'element',
        priority: 600,
        terminal: true,
        restrict: 'A',
        $$tlb: true,
        link: function ($scope: IScope, $element: IAugmentedJQuery, $attr: IAttributes, ctrl, $transclude) {
            var block, childScope, previousElements;

            const spesifikasjon = $attr['kreverTilgangsrolleGrp'];

            $scope.$watch(spesifikasjon, (spek: { rolle: string, gruppeId?: string }) => vis(evaluerObjektSpek(spek)), true);
            $scope.$on(Kontekst.brukerRelastetEvent, () => vis(evaluerObjektSpek($scope.$eval(spesifikasjon)))); //når bruker relastes kan vedkommendes roller ha endret seg

            function evaluerObjektSpek(spek: { rolle: string, gruppeId?: string }): boolean {
                console.log('kreverTilgangsrolleGrp evaluerObjektSpek', spek);

                if (_.isUndefined(spek.rolle))
                    console.warn("forventet objekt av typen {rolle:string, gruppeId?:string} som argument til krever-tilgangsrolle-grp, var: " + spesifikasjon);

                const rolle = lesRolle(spek.rolle);
                const inneharTilgangsrolle = _.isUndefined(spek.gruppeId) ?
                    kontekst.inneharTilgangsrolleINoenGruppe(rolle.navn) :
                    kontekst.inneharTilgangsrolleIGruppe(rolle.navn, spek.gruppeId);
                return inneharTilgangsrolle !== rolle.negert
            }

            function lesRolle(rolleSpek: string) {
                return {
                    navn: l.TilgangsrolleMedlem[_.trimStart(rolleSpek, '!')],
                    negert: _.startsWith(rolleSpek, '!')
                }
            }

            function vis(visElement: boolean) {
                console.log(`krever-tilgangsrolle-grp(${spesifikasjon}) gir ${visElement ? '' : 'ikke'} tilgang`); //Debug

                //KOPIERT FRA angualar.js (ngIfDirective)
                if (visElement) {
                    if (!childScope) {
                        $transclude(function (clone, newScope) {
                            childScope = newScope;
                            clone[clone.length++] = document.createComment(' end kreverTilgangsrolleGrp');
                            // Note: We only need the first/last node of the cloned nodes.
                            // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                            // by a directive with templateUrl when its template arrives.
                            block = {
                                clone: clone
                            };
                            $animate.enter(clone, $element.parent(), $element);
                        });
                    }
                } else {
                    if (previousElements) {
                        previousElements.remove();
                        previousElements = null;
                    }
                    if (childScope) {
                        childScope.$destroy();
                        childScope = null;
                    }
                    if (block) {
                        previousElements = getBlockNodes(block.clone);
                        $animate.leave(previousElements).then(function () {
                            previousElements = null;
                        });
                        block = null;
                    }
                }

            }

        }
    };

}

